<template>
  <div>
    <div class="d-flex flex-fill"></div>
    <!-- CHAT CREATED AT -->
    <div class="text-center sticky-top mb-3">
      <span class="badge bg-white text-primary text-label" style="width: 76px">
        {{ formattedDate }}
      </span>
    </div>
    <template v-for="(item, index) in sectionItems" :key="index">
      <!-- DEFAULT MESSAGE -->
      <div
        class="bg-light py-3 px-3 rounded-5 d-flex mb-3 justify-content-center align-items-center position-relative"
        v-if="item.isDefault"
      >
        <img
          src="@/assets/img/icon_default_message.svg"
          width="30"
          class="position-absolute start-0 ms-4"
        />
        <p class="mb-0 text-center text-label" style="width: 400px">
          {{ defaultMessage }}
        </p>
      </div>

      <!-- DATE -->
      <div class="text-center sticky-top" v-if="item.isHeader">
        <span
          class="badge bg-white border-light text-primary text-label"
          style="width: 76px"
        >
          {{ item.title }}
        </span>
      </div>

      <!-- MESSAGE -->
      <div
        class="chat-message-item d-flex mb-3"
        v-if="!item.isHeader && !item.isDefault"
      >
        <img
          :src="item.image"
          alt=""
          height="38"
          width="38"
          class="rounded-circle me-3 mt-1"
        />
        <div class="flex-grow-1">
          <div class="d-flex align-items-center">
            <p class="mb-0 text-subtitle me-3">{{ item.name }}</p>
            <p class="mb-0 text-label text-muted">{{ item.time }}</p>
            <span
              v-if="item.is_edited || item.edited_at"
              class="ms-2 text-label text-muted"
              style="font-size: 11px"
              >(editado)</span
            >
          </div>
          <template v-if="editingMessageId === item.id">
            <div class="d-flex gap-2 mt-1">
              <input
                class="form-control form-control-sm"
                :value="editMessageText"
                @input="$emit('update:editMessageText', $event?.target?.value)"
                @keyup.enter="$emit('submitEdit', item)"
                @keyup.esc="$emit('cancelEdit')"
              />
              <button
                class="btn btn-sm btn-secondary"
                @click="$emit('submitEdit', item)"
              >
                Salvar
              </button>
              <button class="btn btn-sm btn-light" @click="$emit('cancelEdit')">
                Cancelar
              </button>
            </div>
          </template>
          <p class="text-paragraph mb-0" v-else>{{ item.message }}</p>
        </div>
        <div
          class="ms-2"
          v-if="item.user_id === sessionId && canEditMessage(item)"
        >
          <div class="dropdown">
            <button
              class="btn btn-sm message-menu-btn"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              ⋮
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <button class="dropdown-item" @click="$emit('startEdit', item)">
                  ✏️ Editar mensagem
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

interface ISectionItem {
  isHeader: boolean;
  isDefault: boolean;
  title: string;
  name: string;
  time: string;
  message: string;
  image: string;
  user_id?: number;
  id?: number;
  is_edited?: boolean;
  edited_at?: string | null;
}

export default defineComponent({
  props: {
    sectionItems: {
      type: Array as PropType<ISectionItem[]>,
      required: true,
    },
    defaultMessage: { type: String, required: true },
    formattedDate: { type: String, required: true },
    sessionId: { type: Number, default: null },
    editingMessageId: { type: Number, default: null },
    editMessageText: { type: String, default: "" },
    canEditMessage: { type: Function, default: () => false },
  },
  emits: ["startEdit", "cancelEdit", "submitEdit", "update:editMessageText"],
});
</script>

<style scoped>
.chat-message-item .message-menu-btn {
  visibility: hidden;
  background: transparent;
  border: none;
  font-size: 18px;
  line-height: 1;
  padding: 2px 4px;
  color: #6c757d;
}

.chat-message-item:hover .message-menu-btn,
.chat-message-item .message-menu-btn[aria-expanded="true"] {
  visibility: visible;
}
</style>
